import { LabProcessStatus } from '../hooks/useKits';

const getStatusColor = (status: LabProcessStatus | string): string => {
    switch (status) {
        case LabProcessStatus.Released:
            return '#A9EABA';
        case LabProcessStatus.Rejected:
            return '#FECCB0';
        case LabProcessStatus.Ordered:
            return '#F0F0F0';
        default:
            return '#D6E6FF';
    }
};

export default getStatusColor;
